import React from 'react';
import SizeInput from './parts/SizeInput';
import RoomNameInput from './parts/RoomNameInput';
import BaseUnitInput from './parts/BaseUnitInput';
import { useRecoilValue } from 'recoil';
import { calculationSpecs } from '@state';

const SizeSelector = ({ product, ctx }) => {
  const specs = useRecoilValue(calculationSpecs);

  if (!specs) {
    return null;
  }

  let productType = specs.product_type.name;

  return (
    <div className="sizeSelector" id="sizeSelector">
      <header className="sizeSelector__step">
        <div>
          {productType === 'Organizers' && (
            <button
              type="button"
              className="button"
              data-style="text"
              onClick={() => {
                ctx.emit('openMeasureGuide');
              }}
            >
              How to Measure
            </button>
          )}
        </div>
        {/* <BaseUnitInput></BaseUnitInput> */}
      </header>
      <div className="sizeSelector__dimensions">
        <SizeInput dimension={'width'} specs={specs}></SizeInput>
        <SizeInput dimension={'length'} specs={specs}></SizeInput>
        <SizeInput dimension={'height'} specs={specs}></SizeInput>
      </div>
      {/* <small>* Available height options are determined by width & length measurements.</small> */}
      {/*
       */}
      <hr />

      {/* <RoomNameInput product={product}></RoomNameInput> */}
    </div>
  );
};

export default SizeSelector;
